export const exportToCSV = <T,>(
  filename: string,
  columns: { key: string; label: string }[],
  data: T[],
  renderCell: (item: T, key: string) => any
) => {
  if (!data || data.length === 0) return;

  const headers = columns.map(col => col.label);

  const escapeCsv = (str: any) => {
    if (str === null || str === undefined) return '""';
    const s = String(str).replace(/"/g, '""');
    return `"${s}"`;
  };

  const csvRows = [];
  csvRows.push(headers.map(escapeCsv).join(','));

  data.forEach(item => {
    const row = columns.map(col => renderCell(item, col.key));
    csvRows.push(row.map(escapeCsv).join(','));
  });

  const csvContent = csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
